import {Component, Input, OnInit} from '@angular/core';

import {AdType} from "@numizmat/enumerations";
import {AdCardComponent, AdCardData} from "@numizmat/components";

@Component({
    selector: 'nz-ad-form-step-04',
    imports: [
        AdCardComponent
    ],
    templateUrl: './ad-form-step-04.component.html',
    styleUrl: './ad-form-step-04.component.scss'
})
export class AdFormStep04Component implements OnInit {
  @Input() adCardData!: AdCardData;

  protected firstMockAdCardData!: AdCardData;
  protected secondMockAdCardData!: AdCardData;

  public ngOnInit(): void {
    const date: Date = new Date();

    this.firstMockAdCardData = {
      adId: 'mock-ad-01',
      title: 'Заглавие',
      imageUrl: '',
      price: 11.13,
      adType: AdType.DirectSale,
      expiryDate: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1
      ),
      additionalImageIds: ['1', '2']
    };

    this.secondMockAdCardData = {
      adId: 'mock-ad-02',
      title: 'Заглавие',
      imageUrl: '',
      price: 19,
      adType: AdType.Auction,
      expiryDate: new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 6
      ),
      additionalImageIds: []
    };
  }
}
